
















import { Component, Prop, Vue } from "vue-property-decorator";

import GroupNode0 from "./groupNode0/groupNode0.vue"
import Node from "./node/node.vue"

import * as def from "@/definitions";
@Component({
  components: {
      GroupNode0,
      Node
    }
})
export default class UnDraggableTree extends Vue
{
    @Prop() nodes! : any[];
    @Prop() selectedNode! : any;

    get rootData():def.Data{
        return this.$store.getters.data
    }

    get hierarchy(){
        return 0;
    }

    select(id : number , hierarchy : number){
        // 選択時、カテゴリツリーも開く *閉じる動作は行わない
        this.rootData.openTemplateCategory(id , hierarchy);
        // 選択動作
        this.rootData.selectTemplateCategory(id , hierarchy);
        this.$emit("unDraggableTreeLog", {id : id, hierarchy : hierarchy});
    }

    open(id : number , hierarchy : number){
        this.rootData.openOrCloseTemplateCategory(id , hierarchy);
    }

}
